import reducer from './reducers';
import * as actions from './actions';
import sagas from './sagas';
import * as types from './types';
import Environments from './Environments';

export default Environments;
export { reducer, sagas, actions, types };
